/* eslint-ignore */
// @ts-nocheck

import React, { HTMLProps, useEffect, useMemo, useRef, useState } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { IconBaseProps, IconType } from 'react-icons';

import { Container, CorrectIcon, ErrorText, LabelText } from './styles';

type TextSelectProps = HTMLProps<HTMLSelectElement> & {
  LeadingIcon?: IconType | any | null;
  propsLeadingIcon?: IconBaseProps | null;
  TrailingIcon?: IconType | any | null;
  propsTrailingIcon?: IconBaseProps | null;
  errorMessage?: string | FormikErrors<any>;
  errorCondition?: boolean | FormikTouched<any>;
  isCorrect?: boolean;
  label?: string;
  customHeight?: string;
};

const TextSelect = ({
  LeadingIcon,
  propsLeadingIcon,
  TrailingIcon,
  propsTrailingIcon,
  label,
  errorMessage,
  name,
  errorCondition,
  placeholder,
  isCorrect,
  disabled,
  children,
  customHeight,
  ...rest
}: TextSelectProps): JSX.Element => {
  const inputRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isErrored, setIsErrored] = useState(false);
  const [isLabelActivated, setIsLabelActivated] = useState(false);

  useEffect(() => {
    setIsErrored(!!errorCondition);
  }, [errorCondition]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      // @ts-ignore
      inputRef.current.addEventListener('blur', () => {
        setIsFocused(false);
      });
      // @ts-ignore
      inputRef.current.addEventListener('focus', () => {
        setIsFocused(true);
      });
    }
  }, [inputRef]);

  useEffect(() => {
    // @ts-ignore
    const inputValue = inputRef ? inputRef.current.value || '' : '';
    setIsLabelActivated(!!(isFocused || inputValue.length > 0));
  }, [isFocused]);

  useEffect(() => {
    if (inputRef && inputRef.current) {
      // @ts-ignore
      const inputValue = inputRef ? inputRef.current.value || '' : '';
      setIsLabelActivated(!!(inputValue.length > 0));
    }
  }, [rest, inputRef]);

  const randomId = useMemo(() => {
    const text = label || '';
    return `${text.replace(/\s/g, '')}-${Math.floor(Math.random() * 100)}`;
  }, [label]);

  const LeftIcon = useMemo(() => {
    switch (typeof LeadingIcon) {
      case 'function':
        return LeadingIcon();
      case 'object':
        return LeadingIcon;
      default:
        // return <LeadingIcon {...propsLeadingIcon} />;
        return null;
    }
  }, [LeadingIcon]);

  // const LeftIcon = null;

  const RightIcon = useMemo(() => {
    switch (typeof TrailingIcon) {
      case 'function':
        return TrailingIcon();
      case 'object':
        return TrailingIcon;
      default:
        // return <TrailingIcon {...propsTrailingIcon} />;
        return null;
    }
  }, [LeadingIcon]);

  return (
    <>
      <Container
        isFocused={isFocused}
        isErrored={isErrored}
        // @ts-ignore
        disabled={disabled}
        customHeight={customHeight}
      >
        {LeadingIcon && LeftIcon}
        <div>
          <LabelText
            labelActivated={isLabelActivated}
            id={`labelId-${randomId}`}
          >
            {label}
          </LabelText>
          <select
            id="30"
            name={name}
            ref={inputRef}
            type="text"
            aria-labelledby={`labelId-${randomId}`}
            placeholder={label ? '' : placeholder}
            aria-controls={`control-${randomId}`}
            aria-describedby={`control-${randomId}`}
            {...rest}
            disabled={disabled}
          >
            {children}
          </select>
        </div>
        {inputRef &&
          inputRef.current &&
          // @ts-ignore
          inputRef.current.value &&
          isCorrect && <CorrectIcon size={20} />}
        {TrailingIcon && RightIcon}
      </Container>
      {errorMessage && errorCondition && (
        <ErrorText aria-hidden="true" id={`control-${randomId}`}>
          {`${errorMessage}`}
        </ErrorText>
      )}
    </>
  );
};

TextSelect.defaultProps = {
  LeadingIcon: null,
  propsLeadingIcon: null,
  TrailingIcon: null,
  propsTrailingIcon: null,
  errorMessage: '',
  errorCondition: null,
  isCorrect: null,
  label: '',
  customHeight: '',
};

export default TextSelect;
